import React, { useRef, useState, useEffect, memo } from 'react';
import { Icon } from 'antd'
import { getRandomNumberByRange, sum, square } from './tool';
import './index.css';
export default /*#__PURE__*/ memo(function (_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 320 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 160 : _ref$height,
    _ref$l = _ref.l,
    l = _ref$l === void 0 ? 42 : _ref$l,
    _ref$r = _ref.r,
    r = _ref$r === void 0 ? 9 : _ref$r,
    text = _ref.text,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    onSuccess = _ref.onSuccess,
    onFail = _ref.onFail,
    onRefresh = _ref.onRefresh;


  const [isLoading, setLoading] = useState(true)
  const [sliderLeft, setSliderLeft] = useState(0)
  const [sliderClass, setSliderClass] = useState('sliderContainer')
  const [textTip, setTextTip] = useState(text)

  const info = useRef(null)

  var canvasRef = useRef(null);
  var blockRef = useRef(null);
  var imgRef = useRef(null);
  var isMouseDownRef = useRef(false);
  var trailRef = useRef([]);
  var originXRef = useRef(0);
  var originYRef = useRef(0);
  var xRef = useRef(0);
  var yRef = useRef(0);
  var PI = Math.PI;
  var L = l + r * 2 + 3; // 滑块实际边长

  // var drawPath = function drawPath(ctx, x, y, operation) {
  //   ctx.beginPath();
  //   ctx.moveTo(x, y);
  //   ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI);
  //   ctx.lineTo(x + l, y);
  //   ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI);
  //   ctx.lineTo(x + l, y + l);
  //   ctx.lineTo(x, y + l);
  //   // ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true);
  //   ctx.lineTo(x, y);
  //   ctx.lineWidth = 2;
  //   ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
  //   ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)';
  //   ctx.stroke();
  //   ctx.globalCompositeOperation = 'destination-over';
  //   operation === 'fill' ? ctx.fill() : ctx.clip();
  // };

  var createImg = async function createImg(onload) {

    const img = new Image();
    img.onload = onload;

    img.onerror = function () {
      setTimeout(() => {
        img.setSrc();
      }, 5000); // 图片加载失败的时候重新加载其他图片
    };

    img.setSrc = async function (src) {

      if (typeof _ref.getImgInfo === 'function') {
        const { image, verID } = await _ref.getImgInfo()
        const { oriImage, ypos, cutImage, cutImageHeight, cutImageWidth, xpos } = image || {}

        xRef.current = xpos
        info.current = { cutImage, cutImageHeight, cutImageWidth, ypos, verID }
        img.src = `data:image/png;base64,${oriImage}`
      } else {
        img.src = '';
      }
    };

    img.setSrc();

    return img;

  };
  const draw_block = function () {

    if (!info.current) return
    const { cutImage, cutImageHeight, cutImageWidth, ypos, xpos } = info.current
    const img = new Image();
    // img.crossOrigin = 'Anonymous';
    img.onload = function () {

      const blockCtx = blockRef.current.getContext('2d'); // 随机位置创建拼图形状

      blockRef.current.width = cutImageWidth
      blockCtx.drawImage(img, 0, ypos, cutImageWidth, cutImageHeight);
    };

    img.src = `data:image/png;base64,${cutImage}`
  }

  var draw = function draw(img) {
    var canvasCtx = canvasRef.current.getContext('2d');
    canvasCtx.drawImage(img, 0, 0, width, height);
    draw_block()

  };

  var initImg = async function initImg() {
    var img = await createImg(function () {
      setLoading(false);
      draw(img);
    });
    imgRef.current = img
  };

  var reset = function reset() {
    const canvasCtx = canvasRef.current.getContext('2d');
    const blockCtx = blockRef.current.getContext('2d'); // 重置样式
    setSliderClass('sliderContainer');

    setSliderLeft(0)
    blockRef.current.style.left = 0 + 'px'; // 清空画布

    canvasCtx.clearRect(0, 0, width, height);
    blockCtx.clearRect(0, 0, width, height); // 重新加载图片

    setLoading(true);
    imgRef.current.setSrc();
  };

  var handleRefresh = function handleRefresh() {
    reset();
    typeof onRefresh === 'function' && onRefresh();
  };

  var verify = function verify() {
    var arr = trailRef.current; // 拖动时y轴的移动距离

    var average = arr.reduce(sum) / arr.length;
    var deviations = arr.map(function (x) {
      return x - average;
    });
    var stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length);
    var left = parseInt(blockRef.current.style.left);
    return {
      spliced: Math.abs(left - xRef.current) <= 5,
      left,
      verified: stddev !== 0, // 简单验证拖动轨迹，为零时表示Y轴上下没有波动，可能非人为操作
    };
  };

  var handleDragStart = function handleDragStart(e) {
    originXRef.current = e.clientX || e.touches[0].clientX;
    originYRef.current = e.clientY || e.touches[0].clientY;
    isMouseDownRef.current = true;
  };

  var handleDragMove = function handleDragMove(e) {
    if (!isMouseDownRef.current) return false;
    e.preventDefault();
    var eventX = e.clientX || e.touches[0].clientX;
    var eventY = e.clientY || e.touches[0].clientY;
    var moveX = eventX - originXRef.current;
    var moveY = eventY - originYRef.current;
    if (moveX < 0 || moveX + blockRef.current.width >= width) return false;
    setSliderLeft(moveX);
    blockRef.current.style.left = moveX + 'px';
    setSliderClass('sliderContainer sliderContainer_active');
    trailRef.current.push(moveY);
  };

  var handleDragEnd = function handleDragEnd(e) {
    if (!isMouseDownRef.current) return false;
    isMouseDownRef.current = false;
    var eventX = e.clientX || e.changedTouches[0].clientX;
    if (eventX === originXRef.current) return false;
    setSliderClass('sliderContainer');

    const { spliced, verified, left } = verify();
    const { verID } = info.current

    if (spliced && typeof _ref.verifyPost === 'function') {

      if (verified) {

        _ref.verifyPost(left, verID).then(res => {
          console.log(res)
          if (res && res.code === '200') {
            setSliderClass('sliderContainer sliderContainer_success');
            typeof onSuccess === 'function' && onSuccess();
          } else {
            typeof onFail === 'function' && onFail();
            setSliderClass('sliderContainer sliderContainer_fail');
            setTextTip('请再试一次');
            setTimeout(reset, 1000);
          }
        })
      } else {
        setSliderClass('sliderContainer sliderContainer_fail');
        setTextTip('请再试一次');
        setTimeout(reset, 1000);
      }

    } else {
      setSliderClass('sliderContainer sliderContainer_fail');
      typeof onFail === 'function' && onFail();
      setTextTip('验证失败，请再试一次');
      setTimeout(reset, 1000);
    }
  };

  const closeVertify = () => {
    const { onClose } = _ref

    onClose && onClose()
  }

  useEffect(
    function () {
      if (visible) {
        imgRef.current ? reset() : initImg();
      }
    },
    [visible],
  );

  return <div className='vertifyBox' style={{ display: visible ? '' : 'none', }} >
    <div className="vertifyTitle" >拖动下方滑块完成拼图</div>
    <Icon onClick={closeVertify} className='vertifyClose' type="close-circle" />
    <div
      className='vertifyWrap'
      style={{
        width: width + 'px',
        margin: '0 auto',
      }}
      onMouseMove={handleDragMove}
      onMouseUp={handleDragEnd}
      onTouchMove={handleDragMove}
      onTouchEnd={handleDragEnd}
    >
      <div className='canvasArea' >
        <canvas ref={canvasRef} width={width} height={height} />
        <canvas
          ref={blockRef}
          className='block'
          width={width}
          height={height}
          onMouseDown={handleDragStart}
          onTouchStart={handleDragStart}
        />
      </div>
      <div
        className={sliderClass}
        style={{
          pointerEvents: isLoading ? 'none' : 'auto',
          width: width + 'px',
        }}
      >
        <div className='sliderMask'>
          <div
            className='slider'
            style={{ left: sliderLeft + 'px' }}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
          ><div className='sliderIcon' >III</div></div>
        </div>
        <div className='sliderText' >{textTip}</div>
      </div>
      <div
        className='refreshIcon'
        onClick={handleRefresh}
      ><Icon type="reload" /></div>
      <div
        className='loadingContainer'
        style={{
          width: width + 'px',
          height: height + 'px',
          display: isLoading ? '' : 'none',
        }}
      ><span>{'\u52A0\u8F7D\u4E2D...'}</span></div>
    </div>
  </div>


});
